import badgeDark from '../assets/brand/mgl-badge-dark.svg';
import FrameShell from './FrameShell';

/* The MGL Partner Portal brand dashboard, recreated from the live portal
   with believable sample numbers. Consistent with the shop screenshot:
   Tour Hat $32, Caddy Towel $24, Performance Polo $58. */

const KPIS = [
  ['Today’s sales', '$186.00', '2 orders'],
  ['Last 7 days', '$1,240.00', '14 orders'],
  ['To ship', '4', 'labels ready'],
  ['Followers', '63', 'players following the brand'],
];

const TOP = [
  ['MGL Tour Hat', '9 sold', '$288'],
  ['MGL Caddy Towel', '7 sold', '$168'],
  ['MGL Performance Polo', '4 sold', '$232'],
];

const NAV = [
  ['Dashboard', true],
  ['Analytics', false],
  ['Shop Products', false],
  ['Inventory', false],
  ['Brand Feed', false],
];

export default function PartnerFrame({ maxWidth }) {
  return (
    <FrameShell caption="MGL Partner Portal · sample data" maxWidth={maxWidth} domain="partner.mygolflinks.com">
      <div className="pf-grid">
        <div className="pf-side on-pine" style={{ background: 'var(--pine-deep)', padding: '14px 10px' }}>
          <img src={badgeDark} alt="" width="92" height="35" style={{ display: 'block', margin: '2px 4px 2px' }} />
          <div className="mono" style={{ fontSize: 8, letterSpacing: '0.22em', color: 'var(--gold-bright)', margin: '0 6px 10px' }}>
            PARTNER PORTAL
          </div>
          <div style={{ display: 'flex', gap: 3, margin: '0 4px 12px' }}>
            <span className="mono" style={{ fontSize: 8, padding: '3px 8px', borderRadius: 10, color: 'var(--cream-faint)', border: '1px solid rgba(243,240,228,0.2)' }}>Wholesale</span>
            <span className="mono" style={{ fontSize: 8, padding: '3px 8px', borderRadius: 10, background: 'var(--cream)', color: 'var(--pine-deep)', fontWeight: 600 }}>Brand</span>
          </div>
          {NAV.map(([label, active]) => (
            <div
              key={label}
              style={{
                fontSize: 10.5, fontWeight: active ? 700 : 500, padding: '6px 8px', borderRadius: 6,
                color: active ? 'var(--cream)' : 'var(--cream-faint)',
                background: active ? 'rgba(243,240,228,0.12)' : 'transparent',
              }}
            >
              {label}
            </div>
          ))}
        </div>

        <div style={{ padding: '16px 18px 18px' }}>
          <div style={{ fontSize: '1.15rem', fontWeight: 750, letterSpacing: '-0.02em' }}>Brand Dashboard</div>
          <div style={{ fontSize: 10.5, color: 'var(--mut)', margin: '2px 0 13px' }}>6 live products · 3 buyers this month</div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(105px, 1fr))', gap: 8, marginBottom: 13 }}>
            {KPIS.map(([label, big, sub]) => (
              <div key={label} style={{ background: 'var(--card)', border: '1px solid var(--line-soft)', borderRadius: 9, padding: '9px 11px' }}>
                <div style={{ fontSize: 8.5, fontWeight: 650, color: 'var(--mut)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{label}</div>
                <div className="mono" style={{ fontSize: '1rem', fontWeight: 600, margin: '2px 0 1px' }}>{big}</div>
                <div style={{ fontSize: 8.5, color: 'var(--faint)' }}>{sub}</div>
              </div>
            ))}
          </div>

          <div style={{ fontSize: 9.5, fontWeight: 700, color: 'var(--mut)', marginBottom: 6 }}>Top products, last 30 days</div>
          <div style={{ display: 'grid', gap: 5 }}>
            {TOP.map(([name, sold, rev]) => (
              <div key={name} style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'var(--card)', border: '1px solid var(--line-soft)', borderRadius: 7, padding: '6px 11px' }}>
                <span style={{ fontSize: 10, fontWeight: 600 }}>{name}</span>
                <span style={{ fontSize: 9.5, color: 'var(--mut)' }}>{sold}</span>
                <span className="mono" style={{ marginLeft: 'auto', fontSize: 10, fontWeight: 600 }}>{rev}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </FrameShell>
  );
}
